import { Navigate } from 'react-router';
import React from 'react';
import useAuth from 'src/hooks/useAuth';
import useHasPermissions from 'src/hooks/useHasPermission';

interface PermissionGuardProps {
  hasPermission?: string;
  anyOfPermissions?: string[];
  children: React.ReactNode;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  hasPermission,
  anyOfPermissions,
  children,
}) => {
  const checkPermissions = useHasPermissions();
  const { user } = useAuth();

  const isAllowed = anyOfPermissions?.length
    ? anyOfPermissions.some((permission) => user?.permissions?.includes(permission))
    : hasPermission
      ? checkPermissions([hasPermission])
      : false;

  if (!isAllowed) {
    return <Navigate to="/404" />;
  }

  return <>{children}</>;
};

export default PermissionGuard;
